// components/FileInput.tsx
import React from 'react';

const FileInput = ({ value, onChange, label = "Choose File", title = "Web Image" }) => {
  const fileInputRef = React.useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      onChange(e.target.files[0]);
    }
  };

  return (
    <div>
      <label className="block text-xs font-medium text-slate-700 mb-1">{title}</label>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={handleButtonClick}
          className="w-24 h-8 text-xs rounded  bg-green-400 text-white border-green-400 hover:bg-blue-600 hover:text-black transition-colors"
        >
          {label}
        </button>
        {value && <span className="text-sm text-gray-700">{value.name}</span>}
        <input
          ref={fileInputRef}
          type="file"
          className="hidden"
          onChange={handleFileChange}
        />
      </div>
    </div>
  );
};

export default FileInput;
